
export const LOGIN = "/login";
//export const HOME = "/";
export const ORDERS = "/";
export const SIGNUP = "/signup";
export const ORDER_DETAILS = `/:orderId`;
export const INVENTORY = "/inventory";
export const PROFILE = "/profile";
export const NOTIFICATIONS = "/notification";